// i18next backend that has no locale files to read: every namespace resolves
// empty so i18next falls back to the inline English default strings.
class WebNoFilesBackend {
    constructor(services, options) {
        this.init(services, options);
    }
    init() {}
    read(_language, _namespace, callback) {
        callback(null, {});
    }
    create() {}
}

WebNoFilesBackend.type = "backend";

module.exports = WebNoFilesBackend;
module.exports.default = WebNoFilesBackend;
